import React, { Component } from 'react';
import CustomLoader from '../../common/Loader';
import Tooltip from "@material-ui/core/Tooltip";
import * as Icon from "react-feather";
import { getDisplayEditInfo, getDisplayEditInfoDSColumns } from '../../../services/formService';
import { getDataSources } from '../../../services/dataSourceService';
import { toaster } from '../../../config';
import queryString from 'query-string';

class DisplayEditInfoViewer extends Component {
    DataSources = [];

    state = {
        Widget_ID: this.props.Widget_ID,
        Form_ID: this.props.Form_ID,
        DEI_ID: 0,
        Display_Name: '',
        Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
        loading: true,
        displayColumns: [],
        PrimaryKey: this.props.PrimaryKey ? this.props.PrimaryKey : queryString.parse(window.location.search).pk ? queryString.parse(window.location.search).pk : null,
    };

    constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.copyString = this.copyString.bind(this);
    }

    async componentDidMount() {
        const { data: dataDS } = await getDataSources();
        this.DataSources = dataDS;
        const { data: preloadData } = await getDisplayEditInfo(this.state.Widget_ID);
        if (preloadData[0]) {
            this.setState({
                DEI_ID: preloadData[0].DEI_ID || 0,
                DataSource_ID: preloadData[0].DataSource_ID || 0,
                ResultSource_ID: preloadData[0].ResultSource_ID || 0,
                Display_Name: preloadData[0].Display_Name || '',
                ResultSource_Content: preloadData[0].ResultSource_Content || '',
                displayColumns: JSON.parse(preloadData[0].jsonColumns) || [],
                connStr: this.getConn(preloadData[0].DataSource_ID) || '',
                isSPParameterized: preloadData[0].isSPParameterized || false
            });
            let {data: DSConfig} = await getDisplayEditInfoDSColumns(this.state, 'viewer')
            DSConfig = eval(DSConfig)

            //console.log('preloadData: ',preloadData[0], DSConfig)
            
            //console.log('this.state.Widget_ID:', this.state.Widget_ID)
            //Del pk_val and pk_name: IS TEMPORARY
            delete DSConfig[0]
            delete DSConfig[1]
            let displayColumns = this.state.displayColumns
            DSConfig = DSConfig.filter(function (el, idx) {
                if (displayColumns.some(col => col['Column_ID']+2 === idx)) {
                    //console.log(el, idx)
                    return el
                }
            });

            this.setState({ DSConfig })
            this.setState({ loading: false })
        }
    }

    getConn(DataSource_ID) {
        const source = this.DataSources.find((source) => {
            return source.DataSource_ID === DataSource_ID;
        });
        return source.Connection_String;
    }

    handleChange = (input, idx) => {
        this.setState({ [input.name]: input.value });
        let DSConfig = this.state.DSConfig
        DSConfig[idx]=input.value
        this.setState({DSConfig})
    };

    copyString(Widget_ID) {
        let tempName = [], tempVal = []
        this.state.displayColumns.filter(
            function (col) {
                if (col['enableCopy']) {
                    tempName.push(' '+col.Column_Name)
                    tempVal.push((' '+document.getElementById('w' + Widget_ID + '-' + col.Column_ID).value) || undefined)
                }
            }
        )
        navigator.clipboard.writeText(tempName + '\n' + tempVal).
            then(function () {
                //navigator.clipboard.readText().then((e)=>console.log('Copied Text: ', e))
                toaster('success', 'Copy to Clipboard Success')
            }).
            catch((e) => {
                console.error('Copy to Clipboard Error: ', e);
                toaster('error', 'Copy to Clipboard failed')
            });
    }

    enableEdit(Widget_ID){
        this.state.displayColumns.forEach(
            function(col){
                if(col['isEditable'])
                {
                    var el = document.getElementById('w'+Widget_ID+'-'+col.Column_ID)
                    el.removeAttribute('readOnly')
                }
            }
        )
    }

    SaveColumns(Widget_ID){
        this.state.displayColumns.forEach(
            function(col){
                if(col['isEditable'])
                {
                    var el = document.getElementById('w'+Widget_ID+'-'+col.Column_ID)
                    el.setAttribute('readOnly','readOnly')
                }
            }
        )
        //if state changed, save and re-render the section
        toaster('success','Edited Info Saved')
    }

    render() {
        const { Widget_ID, Display_Name, displayColumns, DSConfig } = this.state
        if (this.state.loading) {
            return <CustomLoader loading={this.state.loading} />;
        }
        return (
            <React.Fragment>
                <div className='card mt-2 mb-2'>
                    <div className='card-header'>
                        <span className='text-primary'>{Display_Name}</span>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Tooltip title="Copy String">
                            <span
                                className="badge badge-teal" onClick={() => this.copyString(Widget_ID)}>
                                <Icon.Copy size={20} />
                            </span>
                        </Tooltip>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Tooltip title="Edit" className='d-none'>
                            <span
                                className="badge badge-yellow" onClick={() => this.enableEdit(Widget_ID)}>
                                <Icon.Edit size={20} />
                            </span>
                        </Tooltip>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Tooltip title="Save" className='d-none'>
                            <span
                                className="badge badge-cyan" onClick={() => this.SaveColumns(Widget_ID)}>
                                <Icon.Save size={20} />
                            </span>
                        </Tooltip>
                    </div>
                    <div className='row card-body pt-1'>
                        {
                            DSConfig.map((col, idx) => (
                                <div className='input-container mr-2 mb-1'>
                                    <label className='font-weight-bold' htmlFor={'w'+Widget_ID+'-'+displayColumns[idx].Column_ID}>{displayColumns[idx].Column_Name}</label>
                                    <input type='text' className='form-control output mt-n1' 
                                            //name={displayColumns[idx].Column_ID} 
                                            id={'w'+Widget_ID+'-'+displayColumns[idx].Column_ID} 
                                            readOnly='readOnly'
                                            value={col} 
                                            onChange={(e) => this.handleChange(e.target, idx)}/>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default DisplayEditInfoViewer;